import { appendScript } from '../../utils/appendScript';
import { formatDate } from '../../utils/commonFunctions';

export const getMyStepData = (data) => {
	const {
		o_level,
		r_level,
		w_level,
		l_level,
		s_level,
		o_level_range,
		r_level_range,
		w_level_range,
		l_level_range,
		s_level_range,
		free_test,
		last_attempts,
		detailed_report,
		active_course_id,
		showScore = true,
		upnext: { element_name, element_type, element_id, attempt_id },
	} = data;

	appendScript('profileUpdate');
	appendScript('easypiechart');
	appendScript('easypiechart-data');

	if (!localStorage.getItem('active_course_id')) {
		localStorage.setItem('active_course_id', active_course_id);
	}

	return {
		score: {
			oLevel: getScore(o_level, free_test, o_level_range),
			rLevel: getScore(r_level, free_test, r_level_range),
			wLevel: getScore(w_level, free_test, w_level_range),
			lLevel: getScore(l_level, free_test, l_level_range),
			sLevel: getScore(s_level, free_test, s_level_range),
			showScore,
		},
		report: {
			isFreeTest: free_test,
			currentLevelDesc: getCurrentLevelDesc(o_level),
			data: getDataOptions(last_attempts),
			isReport: detailed_report.toLowerCase() === 'yes',
			type: 'Line',
		},
		upNext: {
			elementName: element_name,
			elementType: element_type,
			elementId: element_id,
			attemptId: attempt_id,
		},
	};
};

const getScore = (score, isFreeCourse, range) => {
	return isFreeCourse ? range : !!score ? score.toFixed(1) : '--';
};

const getCurrentLevelDesc = (olevel) => {
	let currentLevelDesc = '';
	if (olevel > 0) {
		if (olevel > 0 && olevel < 3) {
			//currentLevel = '1-2 The first step of English'
			currentLevelDesc =
				'Beginner <br> <span style="font-size:20px;">1-3 <br></span> The first step <br> of English';
		} else if (olevel >= 3 && olevel < 5) {
			//currentLevel='3-4 Low skilled, retail (vocational)'
			currentLevelDesc =
				'Elementary <br> <span style="font-size:20px;">3-5 <br></span> Low skilled, <br>retail (vocational)';
		} else if (olevel >= 5 && olevel < 7) {
			//currentLevel= '5-6 SMEs(vocational)'
			currentLevelDesc =
				'Intermediate <br> <span style="font-size:20px;">5-7 <br></span> SMEs <br>(vocational)';
		} else if (olevel >= 7 && olevel < 9) {
			//currentLevel='7-8 Indian Corporates'
			currentLevelDesc =
				'Upper Intermediate <br> <span style="font-size:20px";>7-9</span> <br> Indian <br>Corporates';
		} else if (olevel >= 9 && olevel < 11) {
			//currentLevel='9-10 Global MNCs'
			currentLevelDesc =
				'Advanced <br> <span style="font-size:20px;">9-11</span> <br> Global <br>MNCs';
		} else if (olevel >= 11) {
			//currentLevel='11-12 Consulting,Business'
			currentLevelDesc =
				'Mastery <br> <span style="font-size:20px;">11+</span> <br> Consulting, <br>Business';
		}
	}
	return currentLevelDesc;
};

const getDataOptions = (lastFiveAttempts) => {
	let dataPoints = [];
	let dataLabels = [];
	if (!!lastFiveAttempts) {
		dataPoints = Object.keys(lastFiveAttempts).map(
			(attempt_id) => lastFiveAttempts[attempt_id].o_level,
		);
		dataPoints.reverse();
		dataLabels = Object.keys(lastFiveAttempts).map((attempt_id) =>
			formatDate(lastFiveAttempts[attempt_id].submit_time, 'D MMM YYYY'),
		);
		dataLabels.reverse();
	}

	return {
		labels: dataLabels,
		series: [dataPoints],
	};
};
